import Icon from '../components/Icon';

const Caution = Icon(
  'caution',
  <>
    <path d="M12.75 9a.75.75 0 0 0-1.5 0v4a.75.75 0 0 0 1.5 0zM12 16a1 1 0 1 0 0 2 1 1 0 0 0 0-2" />
    <path
      fillRule="evenodd"
      d="M9.603 3.731c1.052-1.869 3.743-1.869 4.794 0l7.83 13.92c1.031 1.834-.293 4.1-2.397 4.1H4.17c-2.103 0-3.428-2.266-2.397-4.1zm3.487.736a1.25 1.25 0 0 0-2.18 0l-7.83 13.92a1.25 1.25 0 0 0 1.09 1.863h15.66a1.25 1.25 0 0 0 1.09-1.863z"
      clipRule="evenodd"
    />
  </>
);

export default Caution;
